import React, { FC } from 'react';

import { REWARD_CALENDAR_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { ColorPicker } from 'components/ui/ColorPicker/color-picker';

import { useFormFieldsContext } from '../../../context';
import {
  FormFieldsIdentitySection,
  FormFieldsSection,
  FormFieldsUploadSection
} from '../components';

import {
  MAIN_DESIGN_UPLOAD_FIELDS,
  SUB_DESIGN_UPLOAD_FIELDS
} from './RewardCalendarFormFields.consts';

export const RewardCalendarFormFields: FC = (): React.ReactElement => {
  const { values, setFieldValue } = useFormFieldsContext();

  const backgroundColorValue =
    values.backgroundColor || REWARD_CALENDAR_DEFAULTS.backgroundColor;

  return (
    <React.Fragment>
      <FormFieldsSection
        heading="Reward Calendar"
        description="Customize the Reward Calendar to fit your store theme."
      >
        <FormFieldsIdentitySection />
      </FormFieldsSection>

      <FormFieldsSection heading="Main Design" showSeparator>
        <FormFieldsUploadSection fields={MAIN_DESIGN_UPLOAD_FIELDS} />
      </FormFieldsSection>

      <FormFieldsSection heading="Sub Design" showSeparator headingBottomMargin>
        <div className="flex gap-5">
          <div className="flex-1">
            <ColorPicker
              label="Background Color"
              data-testid="offer-design-reward-calendar-sub-background-color-input"
              defaultValue={backgroundColorValue}
              onChange={(color) => setFieldValue('backgroundColor', color)}
            />
          </div>
          <div className="flex-1">
            <ColorPicker
              label="Day Font Color"
              data-testid="offer-design-reward-calendar-sub-day-font-color-input"
              defaultValue={
                values.dayFontColor || REWARD_CALENDAR_DEFAULTS.dayFontColor
              }
              onChange={(color) => setFieldValue('dayFontColor', color)}
            />
          </div>
        </div>

        <FormFieldsUploadSection
          fields={SUB_DESIGN_UPLOAD_FIELDS}
          spacing="lg"
        />
      </FormFieldsSection>
    </React.Fragment>
  );
};
